import { defineComponent as _defineComponent } from 'vue';
import ObjectStoreSelectButton from "@/components/ObjectStore/ObjectStoreSelectButton.vue";
import ObjectStoreSelectButtonDescribePopover from "@/components/ObjectStore/ObjectStoreSelectButtonDescribePopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RelocateDialog',
    props: {
        fromObjectStore: null,
        targetObjectStores: null
    },
    emits: ["relocate"],
    setup(__props, { emit }) {
        const fromWhat = "This dataset location in a";
        const toWhat = "This dataset will be relocated to";
        return { __sfc: true, emit, fromWhat, toWhat, ObjectStoreSelectButton, ObjectStoreSelectButtonDescribePopover };
    }
});
